export const TRANSLATION_KEYS = {
  CONTACT: 'contact',
  WARRANTY_GUARANTEE: 'warrantyGuarantee',
  BECOME_TRADING_PARTNER: 'becomeTradingPartner',
  WARRANTY_CLAIM: 'warrantyClaim',
  ORDER: 'order',
  ORDER_REQUEST_BIKE: 'orderRequestBike',
  ORDER_REQUEST_SPARE_PART_ACCESSORIES: 'orderRequestSparePartAccessories',
  SHIPPING_STATUS_BIKE: 'shippingStatusBike',
  ORDER_CHANGE: 'orderChange',
  CANCELLATION_REQUEST: 'cancellationRequest',
  EXCHANGE_ITEM: 'exchangeItem',
  CHANGE_DELIVERY_DATE: 'changeDeliveryDate',
  CHANGE_PAYMENT_TERM: 'changePaymentTerm',
  PRODUCT_REQUEST_TECHNICAL_SUPPORT: 'productRequestTechnicalSupport',
  AVAILABILITY_BIKE: 'availabilityBike',
  AVAILABILITY_SPARE_PART: 'availabilitySparePart',
  EBIKE_SYSTEMS: 'ebikeSystems',
  OTHER: 'other',
  PAYMENT_TRANSACTIONS: 'paymentTransactions',
  INVOICE_CORRECTION: 'invoiceCorrection',
  CREDITS: 'credits',
  PAYMENT_AGREEMENT: 'paymentAgreement',
  PROOF_OF_PAYMENT: 'proofOfPayment',
  IMPULSE: 'impulse',
  BOSCH: 'bosch',
  SHIMANO: 'shimano',
  FAZUA: 'fazua',
  FEEDBACK: 'feedback',
  DEALER_PORTAL: 'dealerPortal',
  PROCESS: 'process',
  SAP: 'sap',
  SERVICE: 'service',
  PRODUCT: 'product',
  DELIVERY: 'delivery',
  MASTER_DATA_ADDRESSES: 'masterDataAddress',
  CHANGE_OF_NAME: 'changeOfName',
  CHANGE_OF_ADDRESS: 'changeOfAddress',
  CHANGE_OF_DELIVERY_ADDRESS: 'changeOfDeliveryAddress',
  BACKORDER: 'backorder',
  REQUEST_BATTERIES_CHARGERS: 'requestBatteriesChargers',
  APPLICATION_FOR_MOTORS: 'applicationForMotors',
  COMPLAINT_SPARE_PARTS_DELIVERY: 'complaintSparePartsDelivery',
  GROOVE: 'groove',
  CONTINENTAL: 'continental',
  XION_NEODRIVE: 'xionNeodrive',
  TELEPHONE_CONTACT: 'telephoneContact',
  REPLACEMENT_DELIVERY: 'replacementDelivery',
  PRODUCT_LIABILITY: 'productLiability',
  PAINT_DAMAGE: 'paintDamage',
  PACKAGING_DAMAGE: 'packagingDamage',
  COMPONENT_DAMAGE: 'componentDamage',
  COMPONENT_MOUNTED_INCORRECTLY: 'componentMountedIncorrectly',
  WRONG_COMPONENT_MOUNTED: 'wrongComponentMounted',
  PART_MISSING_ON_DELIVERY: 'partMissingOnDelivery',
  ASKING_FOR_DELIVERY_DATE: 'askingForDeliveryDate',
  PART_NOT_FOUND: 'partNotFound',
  TRANSPORT_DAMAGE: 'transportDamage',
  ASSEMBLY_QUALITY: 'assemblyQuality',
  WHOLE_BIKE: 'wholeBike',
  FRAME: 'frame',
  OTHER_COMPONENT: 'otherComponent',
  BIKE_SOLD_TO_CUSTOMER: 'bikeSoldToCustomer',
  BIKE_SOLD_NOT_TO_CUSTOMER: 'bikeNotSoldToCustomer',
}

export default TRANSLATION_KEYS
